import * as events from '@/events';
import type {
  FindContainersResult,
  FindContainersSite,
} from '@gpx-spa/queries/src/getAccountFindContainers';
import { searchOutcome, stockLevel } from '@/utils/find-containers';

export function trackFindContainersOpened() {
  events.trigger(events.names.FIND_CONTAINERS_OPENED);
}

/** Ids, counts and ranks only: names, addresses and coordinates are customer location data. */
export function containersSearchedPayload({
  containerTypeId,
  destinationGeofenceId,
  radiusMiles,
  radiusMeters,
  result,
}: {
  containerTypeId: number;
  destinationGeofenceId: number;
  radiusMiles: number | null;
  radiusMeters: number | null;
  result: FindContainersResult;
}) {
  return {
    container_type_id: containerTypeId,
    destination_geofence_id: destinationGeofenceId,
    radius_mi: radiusMiles,
    site_count: result.sites.length,
    tracker_count: result.trackers.length,
    result: searchOutcome(result, radiusMeters),
  };
}

export function containerSiteSelectedPayload(
  site: FindContainersSite,
  sites: FindContainersSite[],
  from: 'list' | 'map',
) {
  return {
    geofence_id: site.geofence_id,
    rank: sites.findIndex((s) => s.geofence_id === site.geofence_id) + 1,
    units: site.units,
    stock_level: stockLevel(site),
    from,
  };
}
